import FormFieldItem from "src/common/form/FormFieldItem";
import { MyTabs } from "../Tabs/MyTabs";
import { FormField } from "../ui/form";

import { Input } from "../ui/input";
import { useTranslation } from "react-i18next";
function NotificationTabs(props) {
  const { t } = useTranslation();
  return (
    <MyTabs
      tabRender={(e) => {
        return (
          <>
            <FormField
              required
              control={props.form.control}
              name={e === "ar" ? "title_ar" : "title_en"}
              render={({ field }) => (
                <FormFieldItem
                  required
                  form={props.form}
                  label={t("gloabl.title")}
                >
                  <Input {...field} />
                </FormFieldItem>
              )}
            />
            <FormField
              control={props.form.control}
              name={e === "ar" ? "description_ar" : "description_en"}
              render={({ field }) => (
                <FormFieldItem
                  required
                  form={props.form}
                  label={t("gloabl.description")}
                >
                  <Input {...field} />
                </FormFieldItem>
              )}
            />
          </>
        );
      }}
    ></MyTabs>
  );
}

export default NotificationTabs;
